<template>
  <!-- <div class="button-container">
      <button @click="toggleLanguage">{{ $t('toggleLanguage') }}</button>
  </div> -->
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  methods: {

    toggleLanguage() {
      // 获取当前语言
      const currentLocale = this.$i18n.locale;
      // 切换语言
      if (currentLocale === 'en') {
        this.$i18n.locale = 'zh'; // 切换为中文
      } else {
        this.$i18n.locale = 'en'; // 切换为英文
      }
    }
  }
};
</script>

<style>
.button-container {
  top: 20px;
  right: 20px;
}
</style>